import {useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";
import { BaseUrl } from "../../helper/BaseUrl";

const contactListEndpoint = ApiEndpoints.contact.contactList;

const tableHeader = ["Date", "Name", "phone", "email", "pincode", "city", "state", "country", "company type", "company name", "company website", "address", "business phone", "catalogue", "IP Address", ];
const tbody = ["createdAt", "name", "phone", "email", "pincode",  "city", "state", "country", "company_type", "company_name", "company_website", "address", "business_phone", "catalogue", "ip_address", ];

export default function Partner() {
    const [data, setData] = useState([]);

    const dataFetch = async () => {
    try {
        const response = await ApiRequest("GET", contactListEndpoint);
        const result = response.contacts.map((item) => ({
        ...item,
        catalogue: item.catalogue ? (
            <a href={`${BaseUrl}${item.catalogue}`} target="_blank" rel="noopener noreferrer" download>
            <img src="/assets/view.webp" alt="view" style={{ width: "20px" }}/></a>
        ) : (
            "No file"
        ),
        }));

        setData(result);
    } catch (error) {
        console.log(error);
    }
    };


    useEffect(() => {
        dataFetch();
    }, []);

    const pagename = {
      name: 'Partner With Us',
      user: 'Admin',
      innerpage: 'Partner With Us'
    }

  const contactUsData = data?.filter((item)=> item.form_type === "partner_form");

  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section contact-manage-tab">
        <DataTable
          data={contactUsData}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
    </div>
    </>
  )
}
